module.exports = __webpack_public_path__ + "static/media/pysande-ljud.2a541502.mp3";